/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitializeTaxDeclarationBySmzhIdCommand } from '../../models/initialize-tax-declaration-by-smzh-id-command';

export interface ApiTaxDeclarationInitializeSalesforceInsertPost$Json$Params {
      body: InitializeTaxDeclarationBySmzhIdCommand
}

export function apiTaxDeclarationInitializeSalesforceInsertPost$Json(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializeSalesforceInsertPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializeSalesforceInsertPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializeSalesforceInsertPost$Json.PATH = '/api/TaxDeclaration/initialize-salesforce-insert';
